<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'app',
}
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }

  textarea:focus, input:focus{
    outline: none;
  }

  .level{
    display: none !important;
  }
  
  .table-mobile-sort{
    display: none;
  }

  .is-bottom{
    top: auto !important;
    bottom: 0;
    padding: 0 !important;
  }

  .toast{
    flex-basis: inherit !important;
    max-width: inherit !important;
  }
  
  .notices .toast {
    border-radius: 0 !important;
    margin: 0 !important;
  }
  
  .notices .toast.is-dark {
    width: 100%;
    color: #fff;
    background: #000 !important;
  }
  
  .toast div{
    max-width: 1152px !important;
    margin: 0 auto;
    width: 100%;
    text-align: left;
    padding: 25px 0 ;
  }

  .b-table .table th .th-wrap {
    display: initial !important;
    text-align: center;
  }

  .b-table .table th {
    font-size: 12px;
    color: rgb(138, 138, 138);
  }

  .table tbody {
    font-size: 13px;
    font-family: "plain regular", arial;
    color: #000;
  }

  .detail{
    background: #fff !important;
  }

  .navbar-toggler {
    padding: .25rem 0;
  }
  
</style>
